(function ($) {
  Drupal.behaviors.desire_how_to = {
    attach: function (context) {
      $('#desire_mod5', context).once(function () {
        var thisModuleName = 'desire_mod5';
        var triggerMod = '#desire_mod5';
        var $thismodule = $('#desire_mod5');
        // If module is called in URL, scroll to module.
        var urlHash = window.location.href.split('#')[1];
        // Background Color
        var moduleBackground = $thismodule.data('module-background') || 'dark';
        // Fade in
        var moduleWillFade = false;
        var hasFaded = false;
        var fadeThisModuleScene;
        // Init scrollMagic Controller Class
        var controller = new ScrollMagic.Controller();
        var offset;

        if (urlHash === thisModuleName) {
          $('html,body').animate({
            scrollTop: $thismodule.offset().top - 85
          }, 1500);
        }

        // Apply a css class to the module wrapper based on background in data-module-background
        $thismodule.parent().parent().addClass('desire__module-' + moduleBackground + '-bg');

        // Check if Content Author has specified for module
        // to fade in.
        if ($thismodule.data('scrollmagic') === 1) {
          moduleWillFade = true;
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate({
              opacity: 1,
              paddingTop: '0'
            }, 350, 'easeOutQuad');
          } else {
            return;
          }
        }

        // Content-Author-managed - Module Fade.
        if (moduleWillFade) {
          // Set the offset.
          if ($thismodule.data('offset')) {
            offset = $thismodule.data('offset');
          } else {
            offset = 0;
          }

          // Init scrollMagic Scene Class
          fadeThisModuleScene = new ScrollMagic.Scene({
            triggerElement: triggerMod,
            offset: offset
          }).on('start', function () {
            fadeThisModule();
          });
          controller.addScene([fadeThisModuleScene]);
        }
      });
    }
  };
})(jQuery);
